import React from 'react';
import { Button, Modal, Table } from 'tea-component';
import { useIntl } from 'umi';
import TopicAnalysis from './TopicAnalysis';
import { LanguageType } from '@op/types/common';

export default function TopicAnalysisModal({
  visible,
  transTopic,
  filter,
  language,
  currentTopic,
  records,
  columns,
  close,
  sortData,
  topicList,
}: {
  visible: boolean;
  transTopic: any;
  filter: any;
  language: LanguageType;
  currentTopic: any;
  records: Array<any>;
  columns: Array<any>;
  close: any;
  sortData: (
    list: Array<any>,
    sort: { by: string; order: 'desc' | 'asc' },
  ) => Array<any>;
  topicList: any;
}) {
  const { formatMessage } = useIntl();

  return (
    <Modal
      visible={visible}
      caption={formatMessage({ id: 'Tier 2 Topic Performance' })}
      onClose={close}
      className="dbo-topic-tracking-modal"
    >
      <Modal.Body>
        <Table
          className="dbo-topic-tracking-table"
          bordered="all"
          records={records}
          recordKey={'topic'}
          columns={columns}
        />
        <TopicAnalysis
          topics={[currentTopic]}
          transTopic={transTopic}
          filter={filter}
          topicList={topicList}
          language={language}
          sortData={sortData}
          currentTopic={currentTopic}
          topicLevel="L2"
        ></TopicAnalysis>
      </Modal.Body>
      <Modal.Footer>
        <Button type="primary" onClick={close}>
          {formatMessage({ id: 'Close' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
